import { Suspense, lazy, useEffect } from "react";
import { Navigate } from "react-router-dom";

import { isExamInstructorProfile } from "../../constants/instructors";
import { useResolvedInstructor } from "../../hooks/useResolvedInstructor";

const PracticalExamCalendar = lazy(() =>
   import("../../components/APanel/PracticalExamCalendar/PracticalExamCalendar"),
);

function IPOrarInterne() {
   const { instructor, resolved, user } = useResolvedInstructor();

   useEffect(() => {
      document.title = "Instruire Auto | Orar interne";
   }, []);

   if (user?.role === "INSTRUCTOR" && !resolved) {
      return (
         <main className="main" style={{ padding: 0 }}>
            <div className="dayview__loading" role="status" aria-live="polite">
               <div className="dayview__spinner" />
               <span>Se incarca profilul instructorului...</span>
            </div>
         </main>
      );
   }

   if (
      user?.role === "INSTRUCTOR" &&
      resolved &&
      !isExamInstructorProfile(instructor)
   ) {
      return <Navigate to="/instructor/orarul-meu" replace />;
   }

   if (user?.role === "INSTRUCTOR" && resolved && !instructor?.id) {
      return (
         <main className="main" style={{ padding: 0 }}>
            <div className="dayview__loading" role="status" aria-live="polite">
               <span>Profilul de instructor nu a fost gasit.</span>
            </div>
         </main>
      );
   }

   return (
      <main className="main" style={{ padding: 0 }}>
         <Suspense
            fallback={
               <div className="ultra-view__loading" role="status" aria-live="polite">
                  <div className="ultra-view__spinner" />
                  <span>Se încarcă calendarul intern...</span>
               </div>
            }
         >
            <PracticalExamCalendar
               scopedInstructorId={instructor?.id}
               readOnly
               reservationGradeOnly
            />
         </Suspense>
      </main>
   );
}

export default IPOrarInterne;
